import {Injectable} from '@angular/core';
import {HttpClient, HttpErrorResponse, HttpParams} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {catchError} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class WidgetInfoService {

  private resourcePath: string = 'help-spot';

  constructor(private httpClient: HttpClient) {
  }

  errorHandler(error: HttpErrorResponse) {
    return throwError(error.message || 'server Error');
  }

  public getRequestVolume(httpParams: HttpParams): Observable<any> {
    return this.httpClient
      .get<any>(`${this.resourcePath}/request/volume`, {params: httpParams})
      .pipe(catchError(this.errorHandler));
  }

  public getRequestClosedVolume(httpParams: HttpParams): Observable<any> {
    return this.httpClient
      .get<any>(`${this.resourcePath}/request/closedvolume`, {
        params: httpParams
      })
      .pipe(catchError(this.errorHandler));
  }
}
